var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('pop-dialog', _vm._g(_vm._b({
    attrs: {
      "height": "auto",
      "width": "80%"
    }
  }, 'pop-dialog', _vm.$attrs, false), _vm.$listeners), [_c('div', {
    staticClass: "popNftShards"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("NFT Shards")]), _c('div', {
    staticClass: "shard-list"
  }, _vm._l(_vm.pricesList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "shard-item"
    }, [_c('div', {
      staticClass: "shard-item__title"
    }, [_vm._v("NFT Shards")]), _c('div', {
      staticClass: "shard-item-ship"
    }, [_c('img', {
      attrs: {
        "src": require(`@images/tapcoin/new/niceLucky/icon-ship.png`),
        "alt": ""
      }
    }), _c('div', {
      staticClass: "shard-item-tag"
    }, [_vm._v("+" + _vm._s(_vm.fmt_pre(item.count)))])]), item.isLoading ? _c('div', {
      staticClass: "shard-btn",
      on: {
        "click": function ($event) {
          return _vm.onNFTBuy(item, index);
        }
      }
    }, [_c('div', {
      staticClass: "circleLoading"
    })]) : _c('div', {
      staticClass: "shard-btn",
      on: {
        "click": function ($event) {
          return _vm.onNFTBuy(item, index);
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require(`@images/tapcoin/ton-stars.png`),
        "alt": ""
      }
    }), _vm._v(" " + _vm._s(_vm.fmt_pre(item.stars)) + " ")])]);
  }), 0)]), _c('pop-dialog', {
    attrs: {
      "closeModel": false,
      "show": _vm.selectPayMethodShow,
      "height": "auto",
      "width": "80%"
    },
    on: {
      "update:show": function ($event) {
        _vm.selectPayMethodShow = $event;
      }
    }
  }, [_vm.rowPrice ? _c('div', {
    staticClass: "popSelectPayMethod"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Select Payment Method")]), _c('div', {
    staticClass: "popSelectPayMethod-list"
  }, [_c('div', {
    staticClass: "popSelectPayMethod-item",
    class: _vm.selectPay == 'Stars' && 'active',
    on: {
      "click": function ($event) {
        return _vm.onSelectPay('Stars');
      }
    }
  }, [_c('div', {
    staticClass: "popSelectPayMethod-icon"
  }, [_c('img', {
    attrs: {
      "src": require(`@images/tapcoin/ton-stars.png`),
      "alt": ""
    }
  })]), _vm._v(" " + _vm._s(_vm.fmt_pre(_vm.rowPrice.stars)) + " ")]), _c('div', {
    staticClass: "popSelectPayMethod-item",
    class: _vm.selectPay == 'TON' && 'active',
    on: {
      "click": function ($event) {
        return _vm.onSelectPay('TON');
      }
    }
  }, [_c('div', {
    staticClass: "popSelectPayMethod-icon"
  }, [_c('img', {
    attrs: {
      "src": require(`@images/tapcoin/BIGTON.png`),
      "alt": ""
    }
  })]), _vm._v(" " + _vm._s(_vm.fmt_pre(_vm.rowPrice.ton)) + " ")])]), !_vm.isCheckBtn ? _c('div', {
    staticClass: "popSelectPayMethod-btns"
  }, [_vm.pricesList[_vm.rowPrice.index].isLoading ? _c('div', {
    staticClass: "popSelectPayMethod-btn"
  }, [_c('div', {
    staticClass: "circleLoading"
  })]) : _c('div', {
    staticClass: "popSelectPayMethod-btn",
    on: {
      "click": _vm.onPayment
    }
  }, [_vm._v("Payment")])]) : _c('div', {
    staticClass: "popSelectPayMethod-btns"
  }, [_vm.pricesList[_vm.rowPrice.index].isCheckLoading ? _c('div', {
    staticClass: "popSelectPayMethod-btn"
  }, [_c('div', {
    staticClass: "circleLoading"
  })]) : _c('div', {
    staticClass: "popSelectPayMethod-btn",
    on: {
      "click": _vm.onPayCheckBtn
    }
  }, [_vm._v("Check")])])]) : _vm._e()])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };